import { useEffect } from 'react';
import { Box, ScrollView } from '@betty/moonlight';
import FreeSpinsSection from '../components/FreeSpinsSection/FreeSpinsSection';
import { useNavigation } from '@betty/navigation';
import { useTranslation } from '@betty/i18n';
import DailyGiftSection from '../components/DailyGiftSection/DailyGiftSection';
import WheelSpinSection from '../components/WheelSpinSection/WheelSpinSection';

function RewardsScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('rewards');

  useEffect(() => {
    navigation.setOptions({ title: t('rewards') });
  }, [navigation, t]);

  return (
    <ScrollView>
      <Box gap="space-400" marginBottom="space-1000">
        <FreeSpinsSection />
        <DailyGiftSection />
        <WheelSpinSection />
      </Box>
    </ScrollView>
  );
}

export default RewardsScreen;
